<template>
<div class="chapter">
<div class="inner_page">
<p class="fmhd"><i><b>acknowledgments</b></i></p>
<p class="noindent">I would like to acknowledge all the great people at C&amp;T Publishing for all the work they do with me. I also would like to acknowledge everyone at Shannon Fabrics, especially the sales and marketing people. They have been extremely helpful in providing supplies and inspiration.</p>
<p class="noindentt">I also need to acknowledge the helpful staff that I have at the shop. They put in extra hours so that I could get this book done. Well done, ladies!</p>
<p class="fig"><img alt="image" src="images/pg4-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgment.vue?2be8cac6